/**
 * `/organization/permissions` — «Utenti e ruoli»: i ruoli (permessi) di tutte le utenze dell'azienda,
 * dipendenti ed esterni (23-10-2026). Nata come «Autorizzazioni», la scheda di Lares `/hr-authorizations`.
 *
 * La pagina sta in `features/organization/permissions/`; la stessa sul telefono, che è responsiva.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AuthorizationsPage } from '@/features/organization/permissions/AuthorizationsPage';

export const Route = createFileRoute('/_app/organization/permissions')({ component: AuthorizationsPage });
